var React = require('react');
var { connect, useSelector } = require('react-redux');
var distributionActions = require('distributionActions');
const DayPickerInput = require('./DayPickerInput');
var GeneralClasses = require('GeneralClasses');
var dayjs = require('../../../utils/dayjsConfig');
var { upper } = require('helpers');
var env = require('env');
var { unitDisplayName, convert } = require('unitsManager');
var sensorsManager = require('sensorsManager');
var fieldManager = require('fieldManager');
var { shouldWeekStartWithMonday } = require('farmingUnitManager');
var KCBox = require('KCBox');
var CustomMap = require('CustomMap');
var { withTranslation } = require('react-i18next');
var $ = require('jquery');
var SensorsWrapper = require('SensorsWrapper');
var IrrigationSystem = require('IrrigationSystem');
var Fertigation = require('Fertigation');
const WaterTreatmentComponent = require('WaterTreatmentComponent');
const MeteorologicalData = require('./MeteorologicalData');
var {
  get_configuration_config,
  FeatureFlagDictionary,
} = require('remoteConfigurationsManager');
const { useCallback, useMemo } = require('react');
const { PlannerWrapper } = require('PlannerWrapper');

var { isEqual, shouldAdoptFreshField } = require('./updateFieldSyncHelpers');

const UpdateFieldModal = (props) => {
  const {
    userData,
    field_actions,
    soil_data,
    selected_farming_unit,
    selected_distribution,
    configuration_data,
    selected_field,
    create_field,
    update_field,
    clear_field_action,
    t,
    modalId,
  } = props;

  const farming_types_dictionary = useSelector(
    (state) => state?.farming_type_data?.farming_type_data,
  );

  // Memoize to prevent unnecessary rerenders
  const farming_types_dict_memoized = useMemo(
    () => farming_types_dictionary || {},
    [farming_types_dictionary],
  );
  const [state, setState] = React.useState({
    title: '',
    action: '',
    invalid_map_coords_message: '',
    open_edit_section_message: '',
    current_field: new GeneralClasses.Field(),
    areaSize: '',
    soil_type: '',
  });

  // Tracks open (unsaved) sensor/timeframe edit sections. The form cannot be
  // submitted while any of these is open — the user must press Done or Cancel.
  const openEditSectionsRef = React.useRef({
    sensors: false,
    timeFrames: false,
  });

  const field_name = React.useRef(null);
  const formRef = React.useRef(null);
  const cluster_ref = React.useRef(null);
  const custom_map = React.useRef(null);
  // Ref to store current field data for use in event callbacks (avoids stale closure issue)
  const currentFieldRef = React.useRef(null);
  const actionRef = React.useRef('');
  // Baselines for the "adopt fresh Redux data" effect below: the Redux field we
  // last loaded from, and the snapshot we put into state. Used to detect whether
  // the Redux field changed (e.g. a unit-system reload landed) and whether the
  // user has since edited the form.
  const lastSyncedReduxFieldRef = React.useRef(null);
  const lastSyncedSnapshotRef = React.useRef(null);

  // Keep refs in sync with state to avoid stale closure in Bootstrap event handlers
  React.useEffect(() => {
    currentFieldRef.current = state.current_field;
    actionRef.current = state.action;
  }, [state.current_field, state.action]);

  React.useEffect(() => {
    const handleShownBsModal = (event) => {
      let action_type = '';

      if (event.relatedTarget) {
        let button = $(event.relatedTarget);
        action_type = button[0].dataset?.data;
      }

      // Use refs instead of state to avoid stale closure issue
      // (Bootstrap modal events fire before React re-renders with updated state)
      const currentField = currentFieldRef.current;
      const currentAction = actionRef.current;

      if (
        action_type === 'duplicate' ||
        currentAction === 'Update' ||
        currentAction === t('update') ||
        action_type === 'activate'
      ) {
        const polygonData = {
          [currentField.id]: {
            areas: currentField.geo_data.areas,
            title: field_name.current.value,
            fill_color: '#FFFFFF',
          },
        };
        custom_map.current.invalidate(polygonData, {}, {}, true);
      } else {
        custom_map.current.invalidate({}, {}, {}, true);
      }
    };

    const handleShowBsModal = (event) => {
      formRef.current.classList.remove('was-validated');

      // Keep the map's bounds-key farming unit in sync with the currently
      // selected location, otherwise switching locations and opening a field
      // with a colliding id can skip the fly-to-bounds animation (see N-22).
      // custom_map.current is null when is_moderator hides the map section.
      custom_map.current?.setCurrentFarmingUnitId(selected_farming_unit?.id);

      let field_id = '';
      let action_type = '';
      let selected_field = null;

      if (event.relatedTarget) {
        const button = $(event.relatedTarget); // Button that triggered the modal
        field_id = button[0].dataset.id; // Extract info from data-* attributes
        action_type = button[0].dataset?.data; // check if duplicate/activate is pressed?
      }

      if (field_id === '') {
        const startWithMonday = shouldWeekStartWithMonday(
          selected_farming_unit,
          selected_distribution?.name,
        );
        const defaultFirstDayOfWeek = startWithMonday ? 0 : 6; // 0 - Monday, 6 - Sunday
        selected_field = new GeneralClasses.Field(
          undefined,
          undefined,
          defaultFirstDayOfWeek,
        );

        // Update refs immediately for create mode
        currentFieldRef.current = selected_field;
        actionRef.current = t('create');

        setState((prev) => ({
          ...prev,
          title: t('create'),
          action: t('create'),
          invalid_map_coords_message: '',
          open_edit_section_message: '',
          current_field: selected_field,
          soil_type: selected_field.soil_type,
        }));
      } else {
        // Deep clone to avoid Redux state mutation and ensure fresh data
        // Using structuredClone for safe deep cloning (handles undefined, Date objects, etc.)
        if (selected_farming_unit.fields) {
          selected_field = structuredClone(
            selected_farming_unit.fields[field_id],
          );
          // structuredClone strips class prototypes. Rehydrate sensors so
          // instanceof checks (e.g. in sensorObjectsToDictionary) keep working.
          if (selected_field?.sensors) {
            const rehydrated = {};
            for (const sensorId in selected_field.sensors) {
              rehydrated[sensorId] = GeneralClasses.sensorFromJson(
                selected_field.sensors[sensorId],
                sensorId,
              );
            }
            selected_field.sensors = rehydrated;
          }
        }

        let areaSize = calculateArea(selected_field.geo_data?.areas);

        if (
          selected_field.geo_data?.area_size > 0 &&
          selected_field.geo_data.area_size !== areaSize
        ) {
          areaSize = selected_field.geo_data.area_size;
        }

        const newAction =
          action_type === 'duplicate' || action_type === 'activate'
            ? t('create')
            : t('update');

        // Update refs immediately so they're available in shown.bs.modal callback
        currentFieldRef.current = selected_field;
        actionRef.current = newAction;
        // Record the baselines for the adopt-fresh-data effect.
        lastSyncedReduxFieldRef.current = selected_farming_unit.fields
          ? structuredClone(selected_farming_unit.fields[field_id])
          : null;
        lastSyncedSnapshotRef.current = structuredClone(selected_field);

        setState((prev) => {
          return {
            ...prev,
            areaSize: areaSize,
            title: newAction,
            action: newAction,
            invalid_map_coords_message: '',
            open_edit_section_message: '',
            current_field: selected_field,
            soil_type: selected_field.soil_type,
          };
        });
      }

      if (action_type === 'duplicate') {
        field_name.current.value = 'Copy of ' + selected_field.name;

        setState((prevState) => {
          return {
            ...prevState,
            current_field: {
              ...prevState.current_field,
              initial_concentrations: {},
              irrigation_system: {
                ...prevState.current_field.irrigation_system,
                fertigation_concentrations: [],
              },
              contract_data: {
                ...prevState.current_field.contract_data,
                installation_date: dayjs().unix(),
                expiration_date: dayjs().add(1, 'years').unix(),
              },
            },
          };
        });
      } else if (action_type === 'activate') {
        field_name.current.value = selected_field.name;

        setState((prevState) => ({
          ...prevState,
          current_field: {
            ...prevState.current_field,
            settings: {
              ...prevState.current_field.settings,
              field_state: 'active',
            },
          },
        }));
      } else {
        field_name.current.value = selected_field.name;
      }
    };

    const handleHiddenBsModal = () => {
      custom_map.current.resetMap();
      clear_field_action();
    };

    $('#' + modalId).on('shown.bs.modal', handleShownBsModal);
    $('#' + modalId).on('show.bs.modal', handleShowBsModal);
    $('#' + modalId).on('hidden.bs.modal', handleHiddenBsModal);

    return () => {
      $('#' + modalId).off('shown.bs.modal', handleShownBsModal);
      $('#' + modalId).off('show.bs.modal', handleShowBsModal);
      $('#' + modalId).off('hidden.bs.modal', handleHiddenBsModal);
    };
    // Note: field_id is extracted from event.relatedTarget inside handlers, not from component scope.
    // state.current_field is intentionally not a dependency - handlers read fresh state at call time
    // via setState callbacks, avoiding stale closures while preventing unnecessary re-attachments.
  }, [
    modalId,
    selected_farming_unit,
    selected_distribution,
    t,
    clear_field_action,
  ]);

  const autoFill = () => {
    // soil type is a controlled select (state), not a ref — the old
    // soil_type_field ref was never attached and crashed autofill with
    // "Cannot set properties of null (setting 'value')".
    if (field_name.current) {
      field_name.current.value = 'Auto generated field ' + dayjs().unix();
    }

    setState((prevState) => ({
      ...prevState,
      soil_type: 'Sand',
      current_field: {
        ...prevState.current_field,
        soil_type: 'Sand',
        crop_data: {
          ...prevState.current_field.crop_data,
          kc_table: {
            type: 'byGrowthPhase',
            data: {
              byGrowthPhaseGDD: [
                { kc: 1.15, name: 'dummy phase', is_dev: false, duration: 30 },
                { is_dev: true, duration: 10 },
                { kc: 0.9, name: 'late', is_dev: false, duration: 70 },
              ],
              byGrowthPhase: [
                { kc: 1.15, name: 'dummy phase', is_dev: false, duration: 30 },
                { is_dev: true, duration: 10 },
                { kc: 0.9, name: 'late', is_dev: false, duration: 70 },
              ],
              byMonth: {
                jan: '1.01',
                feb: '1.02',
                mar: '1.15',
                apr: '1.15',
                may: '1.16',
                jun: '1.20',
                jul: '1.03',
                aug: '1.03',
                sep: '1.00',
                oct: '0.77',
                nov: '0.76',
                dec: '0.56',
              },
            },
          },
          sow_date: dayjs(1552214813333).format('YYYY-MM-DD'),
        },
        contract_data: {
          ...prevState.current_field.contract_data,
          installation_date: dayjs().unix(),
          expiration_date: dayjs().add(3, 'years').unix(),
        },
      },
    }));
  };

  const calculateArea = (areas) => {
    // calculate area
    fieldArea = fieldManager.getFieldArea(areas);
    fieldAreaConverted = convert(fieldArea, 'dunam', userData.area, 'area');

    return fieldAreaConverted;
  };

  // Adopt fresh field data when the underlying Redux field changes while an
  // (unedited) Update modal is already open. This covers the case where the
  // user changes their unit system and opens the field BEFORE the ~10s
  // distributions reload lands: the backend returns the values already
  // converted, but the modal had snapshotted the old ones and would otherwise
  // only refresh on a full page reload. We never overwrite in-progress edits.
  React.useEffect(() => {
    const fieldId = state.current_field?.id;
    if (!fieldId) return;

    const freshField = selected_farming_unit?.fields?.[fieldId];

    if (
      !shouldAdoptFreshField({
        isUpdateAction: state.action === t('update'),
        hasOpenEditSection:
          openEditSectionsRef.current.sensors ||
          openEditSectionsRef.current.timeFrames,
        freshField,
        lastSyncedReduxField: lastSyncedReduxFieldRef.current,
        currentField: state.current_field,
        lastSyncedSnapshot: lastSyncedSnapshotRef.current,
      })
    ) {
      return;
    }

    // Safe to adopt the fresh field. Rehydrate sensors so instanceof checks work.
    const adopted = structuredClone(freshField);
    if (adopted?.sensors) {
      const rehydrated = {};
      for (const sensorId in adopted.sensors) {
        rehydrated[sensorId] = GeneralClasses.sensorFromJson(
          adopted.sensors[sensorId],
          sensorId,
        );
      }
      adopted.sensors = rehydrated;
    }

    lastSyncedReduxFieldRef.current = structuredClone(freshField);
    lastSyncedSnapshotRef.current = structuredClone(adopted);
    currentFieldRef.current = adopted;
    setState((prev) => ({
      ...prev,
      current_field: adopted,
      areaSize: calculateArea(adopted.geo_data?.areas),
      soil_type: adopted.soil_type,
    }));
  }, [selected_farming_unit, state.current_field, state.action, t]);

  const onAreaChanged = (areas) => {
    let message = { ...state }.invalid_map_coords_message;
    let area_size = calculateArea(areas);

    if (areas && areas.length > 0) {
      message = '';
    }

    setState((prevState) => ({
      ...prevState,
      areaSize: area_size,
      invalid_map_coords_message: message,
      current_field: {
        ...prevState.current_field,
        geo_data: {
          ...prevState.current_field.geo_data,
          areas: areas,
          area_size: area_size,
          agriapi_polygon_ids: [],
        },
      },
    }));
  };

  const onFieldSizeChange = (newFieldSize) => {
    setState((prevState) => ({
      ...prevState,
      areaSize: newFieldSize,
      current_field: {
        ...prevState.current_field,
        geo_data: {
          ...prevState.current_field.geo_data,
          area_size: newFieldSize,
        },
      },
    }));
  };

  const handleMeteorologicalStationAdd = (stationId) => {
    setState((prevState) => {
      const currentStations =
        prevState.current_field.geo_data?.meteorological_stations || [];
      // Add the new station ID if it doesn't already exist
      if (!currentStations.includes(String(stationId))) {
        return {
          ...prevState,
          current_field: {
            ...prevState.current_field,
            geo_data: {
              ...prevState.current_field.geo_data,
              meteorological_stations: [...currentStations, String(stationId)],
            },
          },
        };
      }
      return prevState;
    });
  };

  const handleSensorsChange = (newSensorsObject) => {
    setState((prevState) => {
      return {
        ...prevState,
        current_field: {
          ...prevState.current_field,
          sensors: newSensorsObject,
        },
      };
    });
  };

  const handleKCTableChange = (newKCTable) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        crop_data: {
          ...prevState.current_field.crop_data,
          kc_table: newKCTable,
        },
      },
    }));
  };

  const handleSoilTypeChange = (newSoilType) => {
    setState((prevState) => ({
      ...prevState,
      soil_type: newSoilType,
      current_field: {
        ...prevState.current_field,
        soil_type: newSoilType,
      },
    }));
  };

  const handleFarmingTypeChange = (newFarmingType) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        farming_type: newFarmingType,
      },
    }));
  };

  const handleSoilConcentrationChange = (concentrations) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        initial_concentrations: concentrations,
      },
    }));
  };

  const handleFertigationConcentrationChange = (fcs) => {
    let fcsPlain = fcs.map((currentItem) => {
      return {
        start_date: currentItem.startDate.format('YYYY-MM-DD'),
        fertType: currentItem.fertType,
        concentration: parseFloat(currentItem.concentration),
      };
    });

    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          fertigation_concentrations: fcsPlain,
        },
      },
    }));
  };

  const handleCropDetailsChange = (crop_type, crop_variety, crop_feature) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        crop_data: {
          ...prevState.current_field.crop_data,
          crop_type: crop_type,
          crop_variety: crop_variety,
          crop_feature: crop_feature,
        },
      },
    }));
  };

  const handleSowDateChange = (formattedDate) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        crop_data: {
          ...prevState.current_field.crop_data,
          sow_date: formattedDate,
        },
      },
    }));
  };

  const handleIrrigationDateChange = (formattedDate) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        crop_data: {
          ...prevState.current_field.crop_data,
          irrigation_start_date: formattedDate,
        },
      },
    }));
  };

  const handleHarvestDateChange = (formattedDate) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        crop_data: {
          ...prevState.current_field.crop_data,
          harvest_date: formattedDate,
        },
      },
    }));
  };

  const handleNewExpirationDay = (day) => {
    let newExpirationData = dayjs(day).unix();

    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        contract_data: {
          ...prevState.current_field.contract_data,
          expiration_date: newExpirationData,
        },
      },
    }));
  };

  const handleSettingsChange = useCallback((key, value) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        settings: {
          ...prevState.current_field.settings,
          [key]: value,
        },
      },
    }));
  }, []);

  const handleIrrigationSystemTypeChange = (type) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          irrigation_type: type,
          // Changing the irrigation type resets how the recommendation is
          // shown to that type's default (duration for ndrip/seepage/flood/
          // furrow, amount for the rest). The user can still override it.
          recommendation_display:
            fieldManager.defaultRecommendationDisplay(type),
        },
      },
    }));
  };

  const handleRecommendationDisplayChange = (display) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          recommendation_display: display,
        },
      },
    }));
  };

  const handlePlannerSettingsChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        settings: {
          ...prevState.current_field.settings,
          planner_settings: {
            ...prevState.current_field.settings.planner_settings,
            [key]: value,
          },
        },
      },
    }));
  };

  const handleTankTypeChange = (tankType) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          tank_type: tankType,
        },
      },
    }));
  };
  const handleMeasuredRateStatusChange = (status) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        settings: {
          ...prevState.current_field.settings,
          is_measured_rate_active: status,
        },
      },
    }));
  };
  const handleIrrigationSystemRateChange = (rate) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          irrigation_rate: rate,
        },
      },
    }));
  };

  const handleIrrigationSystemHinChange = (hin) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          irrigation_hin: hin,
        },
      },
    }));
  };

  const handleIrrigationTimeFrameChange = (key, timeFrames) => {
    setState((prevState) => ({
      ...prevState,
      current_field: {
        ...prevState.current_field,
        irrigation_system: {
          ...prevState.current_field.irrigation_system,
          [key]: timeFrames,
        },
      },
    }));
  };

  const updateOpenEditSection = useCallback((section, isOpen) => {
    openEditSectionsRef.current[section] = isOpen;
    // Clear the blocker message once every edit section is closed.
    const anyOpen =
      openEditSectionsRef.current.sensors ||
      openEditSectionsRef.current.timeFrames;
    if (!anyOpen) {
      setState((prev) =>
        prev.open_edit_section_message
          ? { ...prev, open_edit_section_message: '' }
          : prev,
      );
    }
  }, []);

  const handleSensorsEditingChange = useCallback(
    (isOpen) => updateOpenEditSection('sensors', isOpen),
    [updateOpenEditSection],
  );

  const handleTimeFrameEditingChange = useCallback(
    (isOpen) => updateOpenEditSection('timeFrames', isOpen),
    [updateOpenEditSection],
  );

  const onSubmitClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let form = formRef.current;
    let should_submit = form.checkValidity();
    let current_field = { ...state.current_field };

    // Block submit while a sensor or timeframe is mid-edit (not saved/cancelled)
    if (
      openEditSectionsRef.current.sensors ||
      openEditSectionsRef.current.timeFrames
    ) {
      setState((prev) => ({
        ...prev,
        open_edit_section_message: t('edit_field_finish_open_edit_message'),
      }));
      should_submit = false;
    } else {
      setState((prev) => ({ ...prev, open_edit_section_message: '' }));
    }

    // self checks for map values
    if (
      !current_field.geo_data.areas ||
      (current_field.geo_data.areas &&
        current_field.geo_data.areas.length === 0)
    ) {
      setState((prev) => ({
        ...prev,
        invalid_map_coords_message: t('edit_field_choose_area_message'),
      }));
      should_submit = false;
    } else {
      setState((prev) => ({ ...prev, invalid_map_coords_message: '' }));
    }
    // Local check (given by bootstrap)
    if (should_submit) {
      current_field.name = field_name.current.value;
      current_field.cluster.id = cluster_ref.current.value;
      current_field.soil_type = { ...state }.soil_type;

      if (state.action === t('create')) {
        current_field.sensors = sensorsManager.serialNumberCheck(
          current_field.sensors,
        );
        create_field(
          selected_distribution.id,
          selected_farming_unit.id,
          current_field,
        );
      } else if (state.action === t('update')) {
        update_field(
          selected_distribution.id,
          selected_farming_unit.id,
          current_field,
        );

        // check for changes when update field to send the mixpanel
        let changes = checkValuesChangesInField();
        if (Object.keys(changes).length > 0) {
          var changedValues = Object.keys(changes).map(function (key) {
            return key + '=' + changes[key];
          });
          mixpanel.track('Field Update (Event property)', {
            Changes: changes,
            ChangedFields: Object.keys(changes),
            ChangedValues: changedValues,
          });
          mixpanel.track('Recommendation Overrides', {
            Source: 'Edit Field',
            Type: 'Week 0',
          });
        }
      }
    }

    form.classList.add('was-validated');
  };

  const shouldDisableCropType = (installationDate) => {
    const today = dayjs();
    const installDay = dayjs(installationDate);
    const duration = dayjs.duration(today.diff(installDay)).asDays();

    return duration > 60;
  };

  const onLayerSelection = (layerName) => {};

  const checkValuesChangesInField = () => {
    var currentField = state.current_field;
    var originalField = selected_field;
    var changes = {};

    // Field name
    if (
      field_name.current &&
      originalField.name !== undefined &&
      field_name.current.value !== originalField.name
    ) {
      changes['name'] = field_name.current.value;
    }

    // Soil type
    if (currentField.soil_type !== originalField.soil_type) {
      changes['soil_type'] = currentField.soil_type;
    }

    // Farming type
    if (currentField.farming_type !== originalField.farming_type) {
      changes['farming_type'] = currentField.farming_type;
    }

    // Crop data
    if (currentField.crop_data && originalField.crop_data) {
      if (
        currentField.crop_data.crop_type !== originalField.crop_data.crop_type
      ) {
        changes['crop_type'] = currentField.crop_data.crop_type;
      }
      if (
        currentField.crop_data.crop_variety !==
        originalField.crop_data.crop_variety
      ) {
        changes['crop_variety'] = currentField.crop_data.crop_variety;
      }
      if (
        currentField.crop_data.crop_feature !==
        originalField.crop_data.crop_feature
      ) {
        changes['crop_feature'] = currentField.crop_data.crop_feature;
      }
      if (
        currentField.crop_data.sow_date !== originalField.crop_data.sow_date
      ) {
        changes['sow_date'] = currentField.crop_data.sow_date;
      }
      if (
        currentField.crop_data.irrigation_start_date !==
        originalField.crop_data.irrigation_start_date
      ) {
        changes['irrigation_start_date'] =
          currentField.crop_data.irrigation_start_date;
      }
      if (
        currentField.crop_data.harvest_date !==
        originalField.crop_data.harvest_date
      ) {
        changes['harvest_date'] = currentField.crop_data.harvest_date;
      }
      if (
        !isEqual(
          currentField.crop_data.kc_table,
          originalField.crop_data.kc_table,
        )
      ) {
        changes['kc_table'] = 'modified';
      }
    }

    // Irrigation system
    if (currentField.irrigation_system && originalField.irrigation_system) {
      if (
        currentField.irrigation_system.irrigation_rate !==
        originalField.irrigation_system.irrigation_rate
      ) {
        changes['old_irrigation_rate'] =
          originalField.irrigation_system.irrigation_rate;
        changes['new_irrigation_rate'] =
          currentField.irrigation_system.irrigation_rate;
      }
      if (
        currentField.irrigation_system.irrigation_type !==
        originalField.irrigation_system.irrigation_type
      ) {
        changes['irrigation_type'] =
          currentField.irrigation_system.irrigation_type;
      }
      if (
        currentField.irrigation_system.recommendation_display !==
        originalField.irrigation_system.recommendation_display
      ) {
        changes['recommendation_display'] =
          currentField.irrigation_system.recommendation_display;
      }
      if (
        currentField.irrigation_system.tank_type !==
        originalField.irrigation_system.tank_type
      ) {
        changes['tank_type'] = currentField.irrigation_system.tank_type;
      }
      if (
        !isEqual(
          currentField.irrigation_system.fertigation_concentrations,
          originalField.irrigation_system.fertigation_concentrations,
        )
      ) {
        changes['fertigation_concentrations'] = 'modified';
      }
    }

    // Settings
    if (currentField.settings && originalField.settings) {
      if (
        currentField.settings.is_rolling_fit_active !==
        originalField.settings.is_rolling_fit_active
      ) {
        changes['is_planner_active'] =
          currentField.settings.is_rolling_fit_active;
      }
      if (
        currentField.settings.is_dynamic_planner_active !==
        originalField.settings.is_dynamic_planner_active
      ) {
        changes['is_dynamic_planner_active'] =
          currentField.settings.is_dynamic_planner_active;
      }
      if (
        !isEqual(
          currentField.settings.planner_settings,
          originalField.settings.planner_settings,
        )
      ) {
        changes['planner_settings'] = 'modified';
      }
    }

    // Geo data
    if (currentField.geo_data && originalField.geo_data) {
      if (
        currentField.geo_data.area_size !== originalField.geo_data.area_size
      ) {
        changes['area_size'] = currentField.geo_data.area_size;
      }
      if (!isEqual(currentField.geo_data.areas, originalField.geo_data.areas)) {
        changes['areas'] = 'modified';
      }
      if (
        !isEqual(
          currentField.geo_data.meteorological_stations,
          originalField.geo_data.meteorological_stations,
        )
      ) {
        changes['meteorological_stations'] = 'modified';
      }
    }

    // Contract data
    if (currentField.contract_data && originalField.contract_data) {
      if (
        currentField.contract_data.expiration_date !==
        originalField.contract_data.expiration_date
      ) {
        changes['expiration_date'] = currentField.contract_data.expiration_date;
      }
    }

    // Sensors
    if (!isEqual(currentField.sensors, originalField.sensors)) {
      changes['sensors'] = 'modified';
    }

    // Initial concentrations
    if (
      !isEqual(
        currentField.initial_concentrations,
        originalField.initial_concentrations,
      )
    ) {
      changes['initial_concentrations'] = 'modified';
    }

    return changes;
  };

  let is_moderator = selected_farming_unit?.role === 'moderator';

  if (
    field_actions.status === 'success' &&
    ['UPDATE', 'CREATE'].includes(field_actions.type)
  ) {
    $('#' + modalId).modal('hide');
  }

  const isCreateAction = state.action === t('create');
  var installation_date = state.current_field?.contract_data?.installation_date
    ? dayjs
        .unix(state.current_field.contract_data.installation_date)
        .format('YYYY-MM-DD')
    : isCreateAction
      ? dayjs().format('YYYY-MM-DD')
      : '';
  var expiration_date = state.current_field?.contract_data?.expiration_date
    ? dayjs
        .unix(state.current_field.contract_data.expiration_date)
        .format('YYYY-MM-DD')
    : isCreateAction
      ? dayjs().add(1, 'years').format('YYYY-MM-DD')
      : '';

  const measuredIrrigationRateObj = { ...state }.current_field?.historical_data
    ?.measured_irrigation_rate;
  let measuredIrrigationRate = measuredIrrigationRateObj
    ? Object.values(measuredIrrigationRateObj.values)[0]
    : null;
  const featureFlag = get_configuration_config(
    configuration_data,
    FeatureFlagDictionary['WT_PROTOCOL'],
    selected_farming_unit?.name,
    selected_distribution?.name,
  );

  const isNdripIrrigationType =
    state.current_field.irrigation_system.irrigation_type === 'ndrip';
  const shouldFertigationConcentrationBeDisabled =
    fieldManager.getIfThisFieldSupportFert(
      state.current_field?.sensors,
      selected_farming_unit?.sensors,
    );

  return (
    <div
      className='modal fade mb-5 pb-5 text-grey45'
      id={modalId}
      tabIndex='-1'
      role='dialog'
      aria-labelledby='exampleModalLabel'
      aria-hidden='true'
    >
      <form
        className='needs-validation'
        noValidate
        onSubmit={onSubmitClick}
        id='distribution-form'
        style={{ height: '100%' }}
        ref={formRef}
      >
        <div
          className='modal-dialog modal-xl modal-dialog-centered'
          role='document'
          style={{ top: 10, maxHeight: 'calc(100vh - 70px)', height: '100%' }}
        >
          <div
            className='modal-content bg-grey98'
            style={{ alignSelf: 'stretch' }}
          >
            <div
              className='modal-header'
              style={{ background: 'white', height: '72px' }}
            >
              <h5
                className='modal-title ml-2 font-weight-bold text-size-32'
                style={{ lineHeight: 'normal' }}
                id='exampleModalLabel'
              >
                {state.title} {t('field')}
              </h5>
              <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
                style={{
                  color: '#4D5674',
                  opacity: 1,
                  outline: 'none',
                  padding: '24px',
                }}
              >
                <img src={require('images/icons/edit_field/close_icon.svg')} />
              </button>
            </div>
            <div
              className='modal-body pt-0 pb-0'
              style={{ overflowY: 'auto', flex: 1, height: '100%' }}
            >
              <div className='form-row justify-content-center'>
                <div className='col'>
                  <div className='form-group ml-2 mr-2 mt-3 font-weight-bold text-size-20'>
                    <label style={{ marginBottom: '24px' }} htmlFor='fieldName'>
                      {t('edit_field_field_name')}
                    </label>
                    <input
                      type='text'
                      ref={field_name}
                      className='form-control col-sm-4'
                      placeholder={t('edit_field_field_name')}
                      required
                    />
                    <div className='invalid-feedback'>
                      {t('edit_field_field_name_invalid_data_message')}
                    </div>
                  </div>
                </div>
              </div>
              {!is_moderator && (
                <div className='form-row justify-content-center'>
                  <div className='col-12'>
                    <div
                      className='ml-2 mr-2 mt-1 font-weight-bold text-size-20'
                      style={{ pointerEvents: is_moderator ? 'none' : 'auto' }}
                    >
                      <label style={{ marginBottom: '16px' }} htmlFor='sensors'>
                        {t('area')}
                      </label>
                      <CustomMap
                        mapId='edit_field'
                        showEditToolBar={true}
                        onRef={(ref) => (custom_map.current = ref)}
                        map_height='400'
                        onAreaChanged={onAreaChanged}
                        onLayerSelection={onLayerSelection}
                        message={state.invalid_map_coords_message}
                        shouldPresentStressMenu={false}
                        shouldPresentFilePicker={true}
                        shouldPresentPlusButton={false}
                        shouldDisplayNDVI={false}
                      />
                      <div className='d-flex'>
                        <div className='mr-auto'>
                          <small className='form-text text-grey71 text-size-14'>
                            {t('edit_field_area_invalid_data_message')}
                          </small>
                        </div>
                        <div>
                          <small className='form-text text-grey71 text-size-14'></small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className='form-row '>
                <div className='col-12 col-lg-4'>
                  <div
                    className='form-group ml-1 mt-3 font-weight-semi-bold text-size-14'
                    style={{ marginRight: '4px' }}
                  >
                    <label htmlFor='soilType' style={{ marginBottom: '4px' }}>
                      {t('soil_type')}
                    </label>
                    {
                      <select
                        value={
                          t(state.soil_type).toLowerCase() ||
                          t(state.current_field.soil_type).toLowerCase()
                        }
                        onChange={(e) => {
                          handleSoilTypeChange(e.target.value);
                        }}
                        className='form-control custom-select'
                        id='exampleFormControlSelect1'
                        style={{ background: 'none' }}
                      >
                        {soil_data &&
                          soil_data.soil_data &&
                          Object.keys(soil_data.soil_data)
                            .filter(
                              (item) =>
                                soil_data.soil_data[item].active === true,
                            )
                            .sort()
                            .map((item) => {
                              return (
                                <option value={item} key={item}>
                                  {t(upper(item))}
                                </option>
                              );
                            })}
                      </select>
                    }
                  </div>
                </div>
                <div className='col-12 col-lg-4'>
                  <div
                    className='form-group ml-1 mt-3 font-weight-semi-bold text-size-14'
                    style={{ marginRight: '4px', marginLeft: '4px' }}
                  >
                    <label
                      htmlFor='farming_type'
                      style={{ marginBottom: '4px' }}
                    >
                      {t('farming_type')}
                    </label>
                    <select
                      value={
                        Object.keys(farming_types_dict_memoized).filter(
                          (farming_type) => {
                            return (
                              farming_type === state.current_field.farming_type
                            );
                          },
                        )[0]
                      }
                      onChange={(e) => {
                        handleFarmingTypeChange(e.target.value);
                      }}
                      className='form-control custom-select'
                      id='exampleFormControlSelect1'
                      style={{ background: 'none' }}
                    >
                      {Object.values(farming_types_dict_memoized)
                        .sort()
                        .map((item) => {
                          let key = Object.keys(
                            farming_types_dict_memoized,
                          ).filter(function (key) {
                            return farming_types_dict_memoized[key] === item;
                          })[0];
                          return (
                            <option value={key} key={key}>
                              {item}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className='col-12 col-lg-4'>
                  <div className='form-group ml-1 mr-2 mt-3 font-weight-semi-bold text-size-14'>
                    <label htmlFor='fieldSize' style={{ marginBottom: '4px' }}>
                      {t('field_size') + ` (${unitDisplayName(userData.area)})`}
                    </label>
                    <input
                      type='number'
                      className='form-control'
                      id='field_size'
                      required={true}
                      onChange={(event) => {
                        onFieldSizeChange(event.target.value);
                      }}
                      value={state.areaSize}
                      disabled={is_moderator}
                    />
                    <div className='invalid-feedback'>
                      {t('edit_field_field_size_invalid_data_message')}
                    </div>
                  </div>
                </div>
              </div>

              <div className='form-row justify-content-center'>
                <div className='col'>
                  <KCBox
                    selectedField={state.current_field}
                    modalId={modalId}
                    onKCTableChange={handleKCTableChange}
                    onCropDetailsChange={handleCropDetailsChange}
                    onIrrigationDateChange={handleIrrigationDateChange}
                    onSowDateChange={handleSowDateChange}
                    onHarvestDateChange={handleHarvestDateChange}
                    disableCropType={false}
                    isModerator={is_moderator}
                  />
                </div>
              </div>

              {!is_moderator && (
                <IrrigationSystem
                  onMeasuredRateStatusChange={handleMeasuredRateStatusChange}
                  onTankTypeChange={handleTankTypeChange}
                  onIrrigationSystemTypeChange={
                    handleIrrigationSystemTypeChange
                  }
                  onIrrigationSystemRateChange={
                    handleIrrigationSystemRateChange
                  }
                  onRecommendationDisplayChange={
                    handleRecommendationDisplayChange
                  }
                  onNDripHinChange={(hin) =>
                    handleIrrigationSystemHinChange(hin)
                  }
                  initialHin={
                    state.current_field.irrigation_system.irrigation_hin
                  }
                  initialRate={
                    state.current_field.irrigation_system.irrigation_rate
                  }
                  initialType={
                    state.current_field.irrigation_system.irrigation_type
                  }
                  initialRecommendationDisplay={
                    state.current_field.irrigation_system
                      ?.recommendation_display
                  }
                  initialMeasuredRate={measuredIrrigationRate}
                  initialTankType={
                    state.current_field.irrigation_system?.tank_type
                  }
                  initialMeasuredRateStatus={
                    state.current_field.settings?.is_measured_rate_active
                  }
                ></IrrigationSystem>
              )}
              {isNdripIrrigationType && featureFlag && (
                <WaterTreatmentComponent
                  location={'field_modal'}
                  currentFarmingUnit={selected_farming_unit}
                  shouldDisplayAsDisabled={true}
                />
              )}
              <PlannerWrapper
                key={state.current_field.id}
                field={state.current_field}
                handleSettingsChange={handleSettingsChange}
                handleIrrigationTimeFramesChange={
                  handleIrrigationTimeFrameChange
                }
                handlePlannerSettingsChange={handlePlannerSettingsChange}
                onTimeFrameEditingChange={handleTimeFrameEditingChange}
                userData={userData}
              />
              {!is_moderator && (
                <SensorsWrapper
                  current_object={state.current_field}
                  onSensorsChange={handleSensorsChange}
                  onEditingChange={handleSensorsEditingChange}
                  farmingUnitSensors={selected_farming_unit?.sensors}
                />
              )}

              <Fertigation
                key={`fertigation-${state.current_field.id || 'new'}`}
                initial_concentrations={
                  state.current_field.initial_concentrations
                }
                isModerator={is_moderator}
                onFertigationConcentrationChange={
                  handleFertigationConcentrationChange
                }
                onConcentrationChange={handleSoilConcentrationChange}
                initialFertigationConcentrations={
                  state.current_field.irrigation_system
                    .fertigation_concentrations
                }
                shouldFertigationConcentrationBeDisabled={
                  shouldFertigationConcentrationBeDisabled
                }
              />

              <MeteorologicalData
                field={state.current_field}
                onStationAdd={handleMeteorologicalStationAdd}
              />

              <div className='form-row justify-content-start'>
                <div className='col-4'>
                  <div className='form-group ml-2 mr-2 mt-3 font-weight-bold text-size-20'>
                    <label htmlFor='fieldName'>{t('cluster')}</label>
                    <select
                      className='form-control custom-select'
                      ref={cluster_ref}
                      id='exampleFormControlSelect1'
                      defaultValue={state.current_field.cluster.id}
                    >
                      <option value={''} key={0}>
                        {t('none_default')}{' '}
                      </option>
                      <option value={'A'} key={1}>
                        A
                      </option>
                      <option value={'B'} key={2}>
                        B
                      </option>
                      <option value={'C'} key={3}>
                        C
                      </option>
                      <option value={'D'} key={4}>
                        D
                      </option>
                      <option value={'E'} key={5}>
                        E
                      </option>
                      <option value={'F'} key={6}>
                        F
                      </option>
                      <option value={'G'} key={7}>
                        G
                      </option>
                      <option value={'H'} key={8}>
                        H
                      </option>
                      <option value={'I'} key={9}>
                        I
                      </option>
                      <option value={'J'} key={10}>
                        J
                      </option>
                      <option value={'K'} key={11}>
                        K
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {!is_moderator && (
                <div className='form-row justify-content-center'>
                  <div className='col-12 col-lg-6'>
                    <div className='form-group ml-2 mr-2 mt-3 font-weight-bold text-size-20'>
                      <label htmlFor='fieldName'>
                        {t('edit_field_installation_date')}
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='installation_date_input'
                        aria-describedby='installationHelp'
                        placeholder='Installation Date'
                        required
                        disabled
                        value={installation_date}
                      />
                      <div className='invalid-feedback'>
                        {t('edit_field_installation_date_invalid_message')}
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-lg-6'>
                    <div className='form-group ml-2 mr-2 mt-3 font-weight-bold text-size-20'>
                      <label
                        className='font-weight-bold'
                        htmlFor='contract_end_date_input'
                      >
                        {t('edit_field_contract_duration')}
                      </label>
                      <br />
                      <DayPickerInput
                        value={expiration_date}
                        onChange={handleNewExpirationDay}
                        inputProps={{
                          id: 'contract_end_date_input',
                        }}
                      />
                      <div className='invalid-feedback'>
                        {t('edit_field_contract_duration_invalid_message')}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className='form-row justify-content-center mt-4'>
                <div className='text-red text-center'>
                  {state.open_edit_section_message ||
                    (field_actions.status == 'fail' && field_actions.error)}
                </div>
              </div>
            </div>

            <div className='modal-footer' style={{ background: 'white' }}>
              <div className='container text-center'>
                {env.stage == 'local' && (
                  <button
                    type='button'
                    className='btn btn-success'
                    onClick={autoFill}
                  >
                    Auto Fill
                  </button>
                )}

                <button
                  type='button'
                  className='btn m-1 p-0 btn-lg footer-button-cancel'
                  data-dismiss='modal'
                  aria-label='Close'
                >
                  {t('cancel')}
                </button>

                <button
                  type='submit'
                  className='btn m-0 p-0 btn-lg footer-button-save text-white'
                  disabled={
                    ['CREATE', 'UPDATE'].includes(field_actions.type) &&
                    field_actions.status === 'init'
                  }
                >
                  {state.title}

                  {['CREATE', 'UPDATE'].includes(field_actions.type) &&
                    field_actions.status === 'init' && (
                      <span className='ml-2'>
                        <span
                          className='spinner-grow spinner-grow-sm'
                          role='status'
                          aria-hidden='true'
                        ></span>
                      </span>
                    )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    userData: state.authentication_data.user_data,
    field_actions: state.distribution_data.field_actions,
    soil_data: state.soil_data.soil_data,
    selected_farming_unit:
      state.distribution_data.selected_entities.farming_unit,
    selected_distribution:
      state.distribution_data.selected_entities.distribution,
    selected_field: state.distribution_data.selected_entities.field,
    configuration_data: state.configuration_data,
  };
};

const mapDispatchToProps = {
  create_field: distributionActions.create_field,
  update_field: distributionActions.update_field,
  clear_field_action: distributionActions.clear_field_action,
};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(UpdateFieldModal));
